import { useState, useCallback } from 'react';

interface ToastState {
  message: string;
  variant: 'success' | 'error' | 'warning' | 'info';
  isVisible: boolean;
}

export const useToast = () => {
  const [toast, setToast] = useState<ToastState>({
    message: '',
    variant: 'info',
    isVisible: false
  });

  const showToast = useCallback((
    message: string,
    variant: 'success' | 'error' | 'warning' | 'info' = 'info'
  ) => {
    // Asegurar que el mensaje no esté vacío
    if (!message || message.trim() === '') {
      console.warn('Toast called with empty message');
      return;
    }
    
    setToast({
      message: message.trim(),
      variant,
      isVisible: true
    });
  }, []);

  const hideToast = useCallback(() => {
    setToast(prev => ({ ...prev, isVisible: false }));
  }, []);

  return {
    showToast,
    hideToast,
    toast
  };
};

